import React from "react";

export default function WelcomeImage1({ color1, color2 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="87" height="164" viewBox="0 0 87 164">
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rechteck_28"
            data-name="Rechteck 28"
            width="87"
            height="164"
            transform="translate(-245 2866.456)"
            fill="#fff"
            stroke="#707070"
            strokeWidth="1"
          />
        </clipPath>
      </defs>
      <g
        id="Gruppe_maskieren_5"
        data-name="Gruppe maskieren 5"
        transform="translate(245 -2866.456)"
        clipPath="url(#clip-path)"
      >
        <g id="Ebene_2" data-name="Ebene 2" transform="translate(-236.263 2860.386) rotate(25)">
          <g id="OBJECTS" transform="translate(0 0.055)">
            <path
              id="Pfad_218"
              data-name="Pfad 218"
              d="M56.553,242.511c-.981-5.442-1.95-11.587-2.83-17.549-.195-1.318-.384-2.629-.591-3.918-.709-4.94-1.341-9.608-1.844-13.484-.195-1.471-.366-2.83-.526-4.042-.49-3.864-.78-6.269-.78-6.269l-21.727.821L6.5,197.25s-.591,4.757-1.471,11.67c-.165,1.253-.343,2.576-.526,3.959-.485,3.616-1.034,7.61-1.631,11.7v.183c-.189,1.27-.378,2.559-.591,3.841a.142.142,0,0,1,0,.047h0c-.461,3.1-.951,6.2-1.448,9.176-.242,1.229-.431,2.411-.638,3.592L0,242.511Z"
              transform="translate(0 -80.732)"
              fill={color1}
            />
            <path
              id="Pfad_219"
              data-name="Pfad 219"
              d="M16.621,206.874a2.05,2.05,0,1,1-2.044-2.044A2.05,2.05,0,0,1,16.621,206.874Z"
              transform="translate(-5.122 -83.833)"
              fill="#0a777d"
            />
            <path
              id="Pfad_220"
              data-name="Pfad 220"
              d="M25.221,220.3a2.05,2.05,0,1,1-2.05-2.05A2.05,2.05,0,0,1,25.221,220.3Z"
              transform="translate(-8.641 -89.324)"
              fill="#0a777d"
            />
            <path
              id="Pfad_221"
              data-name="Pfad 221"
              d="M42.161,213.37a2.05,2.05,0,1,1-2.05-2.05A2.05,2.05,0,0,1,42.161,213.37Z"
              transform="translate(-15.571 -86.489)"
              fill="#0a777d"
            />
            <path
              id="Pfad_222"
              data-name="Pfad 222"
              d="M15.431,234.58a2.044,2.044,0,1,1-.6-1.449A2.05,2.05,0,0,1,15.431,234.58Z"
              transform="translate(-4.635 -95.166)"
              fill="#0a777d"
            />
            <path
              id="Pfad_223"
              data-name="Pfad 223"
              d="M36.571,233.068A2.05,2.05,0,1,1,34.556,231,2.05,2.05,0,0,1,36.571,233.068Z"
              transform="translate(-13.284 -94.54)"
              fill="#0a777d"
            />
            <path
              id="Pfad_224"
              data-name="Pfad 224"
              d="M9.475,218.88a2.044,2.044,0,0,1-1.855,2.039c.183-1.383.36-2.706.526-3.959a2.044,2.044,0,0,1,1.329,1.92Z"
              transform="translate(-3.118 -88.796)"
              fill="#0a777d"
            />
            <path
              id="Pfad_225"
              data-name="Pfad 225"
              d="M71.031,253.44a2.044,2.044,0,1,1-.6-1.452A2.05,2.05,0,0,1,71.031,253.44Z"
              transform="translate(-27.383 -102.882)"
              fill="#0a777d"
            />
            <path
              id="Pfad_226"
              data-name="Pfad 226"
              d="M69.391,234.58a2.044,2.044,0,1,1-.6-1.452A2.05,2.05,0,0,1,69.391,234.58Z"
              transform="translate(-26.712 -95.166)"
              fill="#0a777d"
            />
            <path
              id="Pfad_227"
              data-name="Pfad 227"
              d="M88.932,241.426a2.05,2.05,0,1,1-.8-3.929,1.583,1.583,0,0,1,.236,0Q88.64,239.447,88.932,241.426Z"
              transform="translate(-35.21 -97.196)"
              fill="#0a777d"
            />
            <path
              id="Pfad_228"
              data-name="Pfad 228"
              d="M72.861,267.27a2.05,2.05,0,1,1-2.05-2.05A2.05,2.05,0,0,1,72.861,267.27Z"
              transform="translate(-28.131 -108.54)"
              fill="#0a777d"
            />
            <path
              id="Pfad_229"
              data-name="Pfad 229"
              d="M87.681,261.74a2.044,2.044,0,1,1-.6-1.452,2.05,2.05,0,0,1,.6,1.452Z"
              transform="translate(-34.195 -106.278)"
              fill="#0a777d"
            />
            <path
              id="Pfad_230"
              data-name="Pfad 230"
              d="M57.334,273.231a2.039,2.039,0,0,0-3.374,0Z"
              transform="translate(-22.076 -111.452)"
              fill="#0a777d"
            />
            <path
              id="Pfad_231"
              data-name="Pfad 231"
              d="M13.161,256.45a2.044,2.044,0,1,1-.6-1.449A2.05,2.05,0,0,1,13.161,256.45Z"
              transform="translate(-3.707 -104.114)"
              fill="#0a777d"
            />
            <path
              id="Pfad_232"
              data-name="Pfad 232"
              d="M5.623,245.631a2.038,2.038,0,0,1-1.773,2.027.142.142,0,0,0,0-.047c.195-1.282.384-2.57.591-3.841A2.056,2.056,0,0,1,5.623,245.631Z"
              transform="translate(-1.575 -99.765)"
              fill="#0a777d"
            />
            <path
              id="Pfad_233"
              data-name="Pfad 233"
              d="M1.789,267.54A2.05,2.05,0,0,1,.33,269.5c.207-1.182.414-2.364.591-3.616a2.05,2.05,0,0,1,.869,1.66Z"
              transform="translate(-0.135 -108.81)"
              fill="#0a777d"
            />
            <path
              id="Pfad_234"
              data-name="Pfad 234"
              d="M21.751,268.734a2.05,2.05,0,1,1-2.044-2.044A2.05,2.05,0,0,1,21.751,268.734Z"
              transform="translate(-7.221 -109.142)"
              fill="#0a777d"
            />
            <path
              id="Pfad_235"
              data-name="Pfad 235"
              d="M40.041,266.033A2.05,2.05,0,1,1,37.99,264a2.05,2.05,0,0,1,2.05,2.033Z"
              transform="translate(-14.704 -108.041)"
              fill="#0a777d"
            />
            <path
              id="Pfad_236"
              data-name="Pfad 236"
              d="M26.991,248.984a2.05,2.05,0,1,1-2.044-2.044A2.05,2.05,0,0,1,26.991,248.984Z"
              transform="translate(-9.365 -101.062)"
              fill="#0a777d"
            />
            <path
              id="Pfad_237"
              data-name="Pfad 237"
              d="M45.6,245.52a2.05,2.05,0,1,1-2.033-2.05A2.05,2.05,0,0,1,45.6,245.52Z"
              transform="translate(-16.979 -99.642)"
              fill="#0a777d"
            />
            <path
              id="Pfad_238"
              data-name="Pfad 238"
              d="M53.981,227.23a2.05,2.05,0,1,1-2.05-2.05A2.05,2.05,0,0,1,53.981,227.23Z"
              transform="translate(-20.407 -92.159)"
              fill="#0a777d"
            />
            <path
              id="Pfad_239"
              data-name="Pfad 239"
              d="M85.156,211.9a1.822,1.822,0,0,1-.443.053,2.05,2.05,0,0,1-.083-4.095C84.789,209.071,84.961,210.43,85.156,211.9Z"
              transform="translate(-33.844 -85.073)"
              fill="#0a777d"
            />
            <path
              id="Pfad_240"
              data-name="Pfad 240"
              d="M65.921,213.37a2.044,2.044,0,1,1-.6-1.449,2.05,2.05,0,0,1,.6,1.449Z"
              transform="translate(-25.292 -86.489)"
              fill="#0a777d"
            />
            <path
              id="Pfad_241"
              data-name="Pfad 241"
              d="M78.621,225.72a2.044,2.044,0,1,1-.6-1.449A2.05,2.05,0,0,1,78.621,225.72Z"
              transform="translate(-30.488 -91.541)"
              fill="#0a777d"
            />
            <path
              id="Pfad_242"
              data-name="Pfad 242"
              d="M57.441,256.45a2.044,2.044,0,1,1-.6-1.449A2.05,2.05,0,0,1,57.441,256.45Z"
              transform="translate(-21.823 -104.114)"
              fill="#0a777d"
            />
            <path
              id="Pfad_243"
              data-name="Pfad 243"
              d="M54.65,144.724c-11.463,7.48-32.5,6.9-45.728,0,1.259-7.87,2.925-15.747,2.564-26.217-.035-1.152-.089-2.293-.148-3.421-.047-.987-.106-1.962-.165-2.925C10.027,94.736,7.037,80.49,8.52,78.647a13.85,13.85,0,0,1,3.008-2.559q.78-.52,1.649-1.064c1.371-.833,2.9-1.678,4.432-2.5,3.634-1.938,7.327-3.74,9.176-4.969a11.7,11.7,0,0,0,4.9,1.217h.266a11.747,11.747,0,0,0,4.869-1.223c1.719,1.14,4.946,2.73,8.272,4.467a70.676,70.676,0,0,1,6.8,3.947,13.519,13.519,0,0,1,2.842,2.488c.727.91.42,4.91-.195,10.843-.591,5.832-1.53,13.531-2.086,22-.154,2.364-.284,4.762-.366,7.209C51.725,128.977,53.385,136.854,54.65,144.724Z"
              transform="translate(-3.32 -27.669)"
              fill={color1}
            />
            <path
              id="Pfad_244"
              data-name="Pfad 244"
              d="M53.612,172.227h0c-9.229-.041-17.106-4.237-22.087-7.752a50.75,50.75,0,0,1-8.692-7.681.45.45,0,0,1,.68-.591,49.8,49.8,0,0,0,8.544,7.557c4.875,3.439,12.574,7.54,21.561,7.581a.443.443,0,0,1,0,.886Z"
              transform="translate(-9.297 -63.876)"
              fill={color1}
            />
            <path
              id="Pfad_245"
              data-name="Pfad 245"
              d="M54.082,168.37c-7.853-1.542-14.813-7.563-15.126-7.841a.443.443,0,0,1-.035-.632.449.449,0,0,1,.626-.041c.083.071,8.272,7.15,16.61,7.912a.437.437,0,0,1,.4.485.455.455,0,0,1-.485.4A18.781,18.781,0,0,1,54.082,168.37Z"
              transform="translate(-15.876 -65.389)"
              fill={color1}
            />
            <path
              id="Pfad_246"
              data-name="Pfad 246"
              d="M44.685,98.2a.443.443,0,0,1-.083-.88c11.227-2.133,14.642-9.371,14.671-9.454a.455.455,0,0,1,.591-.219.443.443,0,0,1,.219.591c-.142.319-3.616,7.735-15.316,9.956Z"
              transform="translate(-18.096 -35.874)"
              fill={color1}
            />
            <path
              id="Pfad_247"
              data-name="Pfad 247"
              d="M51.6,72.017c-2.234,5.093-7.723,10.37-14.861,9.135-6.919-1.182-10.2-4.851-12.562-8.633,3.634-1.944,7.327-3.74,9.176-4.969a11.817,11.817,0,0,0,4.863,1.229h.272A11.853,11.853,0,0,0,43.36,67.55C45.079,68.69,48.3,70.28,51.6,72.017Z"
              transform="translate(-9.893 -27.669)"
              fill="#ffa681"
            />
            <path
              id="Pfad_248"
              data-name="Pfad 248"
              d="M49.518,68.18a.349.349,0,0,0-.355.349c0,.29-.118,7.02-6.163,7.545-5.607.485-7.93-4.881-8.645-7.091a.319.319,0,0,0-.3-.219H33.99a.313.313,0,0,0-.3.414c.768,2.281,3.208,7.829,8.922,7.622h.449c6.689-.591,6.807-8.166,6.807-8.272A.349.349,0,0,0,49.518,68.18Z"
              transform="translate(-13.776 -27.927)"
              fill="#fff"
            />
            <path
              id="Pfad_249"
              data-name="Pfad 249"
              d="M47.823,7.6s5.407,8.367,4.81,17.088.8,18.778-7.008,18.335S23.916,46.149,19.5,39.36,47.823,7.6,47.823,7.6Z"
              transform="translate(-7.808 -3.142)"
              fill="#053a3d"
            />
            <path
              id="Pfad_250"
              data-name="Pfad 250"
              d="M60.776,33.54s1.4,12.621-4.591,16.113-10.334-.4-10.334-.4S58.489,31.638,60.776,33.54Z"
              transform="translate(-18.758 -13.696)"
              fill="#000b29"
            />
            <path
              id="Pfad_251"
              data-name="Pfad 251"
              d="M26.038,32.547s-2.157-2.866-3.758-.5.662,9.383,4.585,7.681Z"
              transform="translate(-8.903 -12.761)"
              fill="#f97853"
            />
            <path
              id="Pfad_252"
              data-name="Pfad 252"
              d="M26.561,39.277a.331.331,0,0,1-.319-.242,5.065,5.065,0,0,0-2.872-3.049.331.331,0,0,1-.195-.425.337.337,0,0,1,.431-.195,5.714,5.714,0,0,1,3.273,3.492.331.331,0,0,1-.23.408Z"
              transform="translate(-9.473 -14.493)"
              fill={color2}
            />
            <path
              id="Pfad_253"
              data-name="Pfad 253"
              d="M24.862,39.09a.313.313,0,0,1-.177-.053.337.337,0,0,1-.1-.461,3.019,3.019,0,0,1,1.241-1,.331.331,0,1,1,.272.591,2.364,2.364,0,0,0-.957.756A.331.331,0,0,1,24.862,39.09Z"
              transform="translate(-10.037 -15.382)"
              fill={color2}
            />
            <path
              id="Pfad_254"
              data-name="Pfad 254"
              d="M65.937,32.547s2.151-2.866,3.752-.5-.662,9.383-4.579,7.681Z"
              transform="translate(-26.638 -12.761)"
              fill="#f97853"
            />
            <path
              id="Pfad_255"
              data-name="Pfad 255"
              d="M66.33,39.276a.331.331,0,0,0,.319-.242,5.065,5.065,0,0,1,2.872-3.049.332.332,0,0,0-.236-.62,5.7,5.7,0,0,0-3.273,3.492.325.325,0,0,0,.23.408Z"
              transform="translate(-27.001 -14.492)"
              fill={color2}
            />
            <path
              id="Pfad_256"
              data-name="Pfad 256"
              d="M69.361,39.09a.325.325,0,0,0,.177-.053.337.337,0,0,0,.1-.461,3.019,3.019,0,0,0-1.241-1,.331.331,0,1,0-.272.591,2.417,2.417,0,0,1,.957.756A.319.319,0,0,0,69.361,39.09Z"
              transform="translate(-27.77 -15.382)"
              fill={color2}
            />
            <path
              id="Pfad_257"
              data-name="Pfad 257"
              d="M49.64,55.75v6.972s-2.08,3.545-4.892,3.793-5.318-3.061-5.318-3.061V56.24Z"
              transform="translate(-16.132 -22.841)"
              fill="#ffa681"
            />
            <path
              id="Pfad_258"
              data-name="Pfad 258"
              d="M49.649,55.75v3.1c-1.891,2.1-5.235,2.836-10.2,2.1V56.229Z"
              transform="translate(-16.14 -22.841)"
              fill="#f97853"
            />
            <path
              id="Pfad_259"
              data-name="Pfad 259"
              d="M51.818,19.384a67.362,67.362,0,0,1-.91,8.8c-.124.68-.272,1.312-.431,1.885C49,35.208,45.336,44.018,35.066,40.348c-4.538-1.619-6.641-6.677-7.581-11.818a49.952,49.952,0,0,1-.685-9.543A7.291,7.291,0,0,1,30.493,12.8c6.062-3.433,12.462-2.157,16.675-.532A7.25,7.25,0,0,1,51.818,19.384Z"
              transform="translate(-10.958 -4.379)"
              fill="#ffa681"
            />
            <path
              id="Pfad_260"
              data-name="Pfad 260"
              d="M38.894,33.324c0,.739-.384,1.347-.857,1.347s-.857-.591-.857-1.347S37.564,32,38.037,32,38.894,32.591,38.894,33.324Z"
              transform="translate(-15.211 -13.125)"
              fill="#053a3d"
            />
            <path
              id="Pfad_261"
              data-name="Pfad 261"
              d="M56.818,33.324c0,.739-.378,1.347-.857,1.347s-.851-.591-.851-1.347S55.476,32,55.949,32,56.818,32.591,56.818,33.324Z"
              transform="translate(-22.547 -13.125)"
              fill="#053a3d"
            />
            <path
              id="Pfad_262"
              data-name="Pfad 262"
              d="M34.794,27.07a14.11,14.11,0,0,1,3.663-.55.632.632,0,0,1,.615.745h0a.632.632,0,0,1-.656.52,16.731,16.731,0,0,0-5.017.591.963.963,0,0,1,.29-.68A2.216,2.216,0,0,1,34.794,27.07Z"
              transform="translate(-13.665 -10.883)"
              fill="#053a3d"
            />
            <path
              id="Pfad_263"
              data-name="Pfad 263"
              d="M56.213,27.11a14.423,14.423,0,0,0-3.658-.55.638.638,0,0,0-.632.75h0a.632.632,0,0,0,.656.52,16.039,16.039,0,0,1,5.017.62.939.939,0,0,0-.313-.68A2.239,2.239,0,0,0,56.213,27.11Z"
              transform="translate(-21.239 -10.899)"
              fill="#053a3d"
            />
            <path
              id="Pfad_264"
              data-name="Pfad 264"
              d="M47.1,40.138a1.43,1.43,0,0,1-.721-.171,1.022,1.022,0,0,1-.479-.8,48.219,48.219,0,0,1,.2-5.194.331.331,0,1,1,.656.053c0,.041-.319,3.918-.2,5.076a.366.366,0,0,0,.165.307,2,2,0,0,0,1.329-.13.343.343,0,0,1,.431.183.325.325,0,0,1-.183.431A3.474,3.474,0,0,1,47.1,40.138Z"
              transform="translate(-18.775 -13.794)"
              fill="#f97853"
            />
            <path
              id="Pfad_265"
              data-name="Pfad 265"
              d="M40.82,48.18A3.916,3.916,0,0,0,44.7,51.725c2.8,0,3.6-2.115,3.87-3.545Z"
              transform="translate(-16.7 -19.744)"
              fill="#fff"
            />
            <path
              id="Pfad_266"
              data-name="Pfad 266"
              d="M46.146,56.763a3.273,3.273,0,0,1-1.554-.455.331.331,0,0,1,.349-.561h0a2.653,2.653,0,0,0,1.182.355,2.913,2.913,0,0,0,1.276-.355.331.331,0,0,1,.455.112.343.343,0,0,1-.112.455,3.545,3.545,0,0,1-1.6.449Z"
              transform="translate(-18.186 -22.82)"
              fill="#f97853"
            />
            <path
              id="Pfad_267"
              data-name="Pfad 267"
              d="M52.563,14.523a1.1,1.1,0,0,1-.8.591,21.152,21.152,0,0,1-.118,2.452c-.408,4.786-1.619,5.625-1.891,4.443a56.594,56.594,0,0,1-.083-6.766,15.038,15.038,0,0,1-1.773-.219l-1.1-4.65-.378,4.609c-1.666.591-5.554-.349-5.554-.349L39.57,10.067l-.833,4.4a9.278,9.278,0,0,1-5.619.408L32.4,10.144,30.748,14.9s-5.318,1.909-5.389,0a36,36,0,0,1,1.465-6.677A10.045,10.045,0,0,1,31.67,2.085a17.655,17.655,0,0,1,16-.23C52.776,4.862,52.563,14.523,52.563,14.523Z"
              transform="translate(-10.375 -0.055)"
              fill="#053a3d"
            />
            <path
              id="Pfad_268"
              data-name="Pfad 268"
              d="M25.253,8.2s-4.39,5.2-5.832,14.536S15.982,38.943,21.6,42.016c6.074,3.333,5.548-3.5,5.466-5.353S21.8,29.732,25.253,15.438C26.363,10.829,25.253,8.2,25.253,8.2Z"
              transform="translate(-7.308 -3.387)"
              fill="#053a3d"
            />
            <path
              id="Pfad_269"
              data-name="Pfad 269"
              d="M28.63,40.79h0c0,.071,0,.437.035,1.022,0,.355.035.792.065,1.294.207,3.138.821,8.562,2.612,10.441a5.97,5.97,0,0,0,3.681,1.264V52.359A9.779,9.779,0,0,1,30.988,48.6a23.044,23.044,0,0,1-2.234-6.884Z"
              transform="translate(-11.713 -16.721)"
              fill="#000b29"
            />
            <path
              id="Pfad_270"
              data-name="Pfad 270"
              d="M68.2,45.443a.78.78,0,1,1-.756-.8A.78.78,0,0,1,68.2,45.443Z"
              transform="translate(-27.264 -18.296)"
              fill="#fff"
            />
            <path
              id="Pfad_271"
              data-name="Pfad 271"
              d="M98.447,77.98s15.233.3,22.388-7.315c2.068-2.2,1.477-32.008,1.477-32.008l-4.727-1.377s-1.82,9.649-2.8,15.126c-.8,4.5-1.483,9.98-1.7,11.788-.041.4-.213,1.365-.213,1.365-.083.307-.189.337-.408.467-6.724,4.03-16.663-.857-16.663-.857Z"
              transform="translate(-39.194 -15.285)"
              fill="#ffa681"
            />
            <path
              id="Pfad_272"
              data-name="Pfad 272"
              d="M127.73,88.6a.467.467,0,0,0,.656-.059.461.461,0,0,0-.041-.656A38.22,38.22,0,0,0,124.238,85c-.071.337-.183.4-.183.4a5.211,5.211,0,0,1-.455.29A35.934,35.934,0,0,1,127.73,88.6Z"
              transform="translate(-50.568 -34.808)"
              fill="#f97853"
            />
            <path
              id="Pfad_273"
              data-name="Pfad 273"
              d="M69.7,75.46S62.2,83.78,70.912,92.832c6.027,6.257,26.046,2.174,26.046,2.174L95.345,80.358S77.944,81.416,69.7,75.46Z"
              transform="translate(-27.288 -30.905)"
              fill={color1}
            />
            <path
              id="Pfad_274"
              data-name="Pfad 274"
              d="M137.541,10.608c-.508.148-1.04,1.968-1.436,3.711h-.189c.284-2.417.591-6.576-.473-6.133-.709.29-1.111,3.841-1.288,5.98h-.313c.177-2.558.366-7.534-.839-6.966-.8.378-1.01,4.727-1.064,7h-.3c.059-2.18,0-6.346-1.182-5.785-1.081.514-.68,6.937-.68,6.937h0l-.142,2.417s-.839.065-1.53-1.607-1.974-2.364-1.672-.189c.349,2.47,1.406,4.514,1.6,6.24s2.2,2.954,2.2,2.954l4.455,1.294s3.4-7.091,2.954-11.227h0C138.067,13.043,138.434,10.366,137.541,10.608Z"
              transform="translate(-51.711 -2.96)"
              fill="#ffa681"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
